import gql from 'graphql-tag';

const GET_DSP_INVENTORY_LISTS = gql`
  query getDspInventoryLists($forceRefresh: Boolean) {
    dspInventoryLists(forceRefresh: $forceRefresh) {
      queryTotal
      data {
        id
        name
        inventoryUsage
        inclusionUsage
        itemCount
        status
      }
    }
  }
`;

export default GET_DSP_INVENTORY_LISTS;
